import { toast } from "react-toastify";
import { useAppDispatch, useAppSelector } from "../../../../reduxToolkit/hooks";
import { removeItems, updateTodo } from "../../../../reduxToolkit/reducers/toDoSlice";
import { ToDoProp } from "../../../../types/Applications";
import { Badge } from "reactstrap";

// This component displays a list of to-do items and allows users to mark them as complete/incomplete or delete them.
const ToDoList = () => {
  const { todoList } = useAppSelector((state) => state.todo);
  const dispatch = useAppDispatch();

  // Function to handle marking a to-do item as completed or pending
  const handleMarkedTodo = (item: ToDoProp) => {
    if (item.status === "completed") {
      dispatch(updateTodo({ id: item.id, status: "pending", badgeClass: "light-danger" }));
      toast.error(item.title + " as Incomplete");
    } else if (item.status === "pending") {
      dispatch(updateTodo({ id: item.id, status: "completed", badgeClass: "light-success" }));
      toast.success(item.title + " as Complete");
    }
  };
  return (
    <div className="todo-list-body">
      <ul id="todo-list">
        {todoList.map((item, i) => (
          <li className={`task ${item.status === "completed" ? "completed" : ""}`} key={i}>
            <div className="task-container">
              <div onClick={() => handleMarkedTodo(item)}>
                <h4 className="task-label">{item.title}</h4>
              </div>
              <div className="d-flex align-items-center gap-3">
                <Badge color="" className={`badge-${item.badge !== "Done" ? item.badgeClass : "light-success"}`} onClick={() => handleMarkedTodo(item)}>
                  {item.badge}
                </Badge>
                <h5 className="assign-name m-0">{item.timeLimit}</h5>
                <span className="task-action-btn">
                  <span className="action-box large" title="Delete Task">
                    <i className="icon">
                      <i className="icon-trash" onClick={() => dispatch(removeItems(item))} />
                    </i>
                  </span>
                </span>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ToDoList;
